// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min
}

let endTimeG

function cutDownTime() {
  let nowTime = new Date()
  let endTime = new Date(endTimeG)

  let leftTime = endTime.getTime() - nowTime.getTime()
  if (leftTime < 0) {
    setupNewCountdown()
    leftTime = 0
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60)
  leftH = leftH >= 10 ? leftH : '0' + leftH
  leftM = leftM >= 10 ? leftM : '0' + leftM
  leftS = leftS >= 10 ? leftS : '0' + leftS

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  }
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9)
  const currentTime = new Date()
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour)
}
let intervalId

function getCutDownTime() {
  setupNewCountdown()
  if (intervalId) clearInterval(intervalId)
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime()
    $('.sp_top_cut_down .sp_left_view .sp_hour').html(cutDownTimeText.hour)
    $('.sp_top_cut_down .sp_left_view .sp_minute').html(cutDownTimeText.minute)
    $('.sp_top_cut_down .sp_left_view .sp_second').html(cutDownTimeText.second)
  }, 1000)
}

getCutDownTime()

function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach(subArray => {
        subArray.forEach(url => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach(url => {
        const img = new Image()
        img.src = url
      })
    }
  }

  new Swiper('.sp-swiper1', {
    autoplay: true,
    autoplay: {
      delay: 3500,
      disableOnInteraction: false,
    },
    slideShadows: true,
    slidesPerView: 'auto',
    spaceBetween: 0,
    centeredSlides: true,
    loop: true,
  })

  const swiper1 = new Swiper('.sp-swiper2', {
    autoplay: {
      disableOnInteraction: false,
      delay: 2500,
    },
    spaceBetween: 0,
    slidesPerView: 'auto',
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.sp-pagination',
      clickable: true,
    },
    on: {
      slideChange: function () {
        // 获取对应的sp-content
        const spContent = document.querySelector(
          '.sp-part7 .sp-content:not([style*="top"])'
        )
        if (spContent) {
          // 移除所有active类
          const items = spContent.querySelectorAll('div')
          items.forEach(item => item.classList.remove('active'))
          // 给当前索引的项添加active类
          const currentIndex = this.realIndex
          if (items[currentIndex]) {
            items[currentIndex].classList.add('active')
          }
        }
      },
    },
  })

  const firstSpContent = document.querySelector(
    '.sp-part7 .sp-content:not([style*="top"])'
  )
  if (firstSpContent) {
    const buttons = firstSpContent.querySelectorAll('div')
    buttons.forEach((button, index) => {
      button.addEventListener('click', function () {
        // 移除所有active类
        buttons.forEach(btn => btn.classList.remove('active'))
        // 添加active类到当前按钮
        this.classList.add('active')
        // 切换到对应的slide
        swiper1.slideTo(index)
      })
    })
  }

  new Swiper('.mySwiper', {
    slidesPerView: 'auto',
    spaceBetween: 35,
    loop: true, //循环滚动
    freeMode: true,
    speed: 6500, //匀速时间
    autoplay: {
      delay: 0,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    allowTouchMove: false,
  })

  

  let prods = window.product
  console.log(prods)
    // let prodss = window.product
//   function getCur(that){
//     let title = $(that).closest('.white-box').find('.sp-btn-style').attr('data-id')
//     // let size = $('#sp-size div.active').attr('data-val')
//     console.log(title,"111")
//     return prods.filter(item=> item.id == title )[0]  
//   }

  
    // let price = (getCur(that).price * num / 100).toFixed(2)
    // let compare = (getCur(that).compare_at_price * num / 100).toFixed(2)
    const id = $('.sp-check div').hasClass('active') ? prods[1].id : prods[0].id

  $('.sp-check div').click(function () {
    
    $(this).toggleClass('active')
    let num = Number($("input[type='number']").val())
        // let that = this
    if ($(this).hasClass('active')) {
    let price = ( prods[1].price * num / 100).toFixed(2).replace('.',',');
    let compare = (prods[1].compare_at_price * num / 100).toFixed(2).replace('.',',');
        console.log(price,compare)
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      $('.sp-product1').hide()
      $('.sp-product2').show()
    } else {
    let price = (prods[0].price * num / 100).toFixed(2).replace('.',',');
    let compare = (prods[0].compare_at_price * num / 100).toFixed(2).replace('.',',');
      $('#sp_price1').html(price)
      $('#sp_price2').html(compare)
      $('.sp-product1').show()
      $('.sp-product2').hide()
    }
  })

  // sp-part10 的 btn-style 点击时选中 sp-check div
  $('.sp-part10 .btn-style2').click(function () {
    $('.sp-check div').addClass('active')
    let that = this
    let num = Number($("input[type='number']").val())
    let price = (prods[1].price * num / 100).toFixed(2).replace('.',',');
    let compare = (prods[1].compare_at_price * num / 100).replace('.',',');
    $('#sp_price1').html(price)
    $('#sp_price2').html(compare)
    $('.sp-product1').hide()
    $('.sp-product2').show()

    const targetElement = document.getElementById('shopping') // 获取跳转目标节点
    const offsetTop = targetElement.offsetTop
    window.scroll({
      top:
        offsetTop * $('div#root').css('zoom') + 198 * $('div#root').css('zoom'),
      behavior: 'smooth', // 使用 smooth 实现平滑滚动
    }) // 方式二
  })

  $('.btn-style').click(function () {
    const id1 = $('.sp-check div').hasClass('active') ? prods[1].id : prods[0].id
    const num = Number($("input[type='number']").val())
    window.location.href = '/cart/' + id1 + ':' + num
  })

  $('.sp-reduce, .sp-add').click(function () {
    // 找到当前按钮所在的商品区域（如 .product-part）
    let $product = $(this).closest('.product-part')
    // 找到数量 input
    let $input = $(this).siblings('input')

    let num = Number($input.val())
    let isCheck = $('.sp-check div').hasClass('active')
     let price = ((isCheck?prods[1].price:prods[0].price) * num / 100).toFixed(2).replace('.',',');
    let compare = ((isCheck?prods[1].compare_at_price:prods[0].compare_at_price) * num / 100).toFixed(2).replace('.',',');
    if ($(this).hasClass('sp-reduce')) {
      num = Math.max(1, num - 1)
    } else {
      num = num + 1
    }
    $input.val(num)

    // 更新当前区域的价格
    $product.find('.sp-span#sp_price1').html(price)
    $product.find('#sp_price2').html(compare)
  })

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    $('.selectl span').click(function () {
      $(this).addClass('on').siblings().removeClass('on')
    })

    $('.selectl span').click(function () {
      $(this).addClass('on').siblings().removeClass('on')
    })

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop
        window.scroll({
          top:
            offsetTop * $('div#root').css('zoom') -
            255 * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }

  // 标题文本渐出
  const graduallyList = document.getElementsByClassName('gradually')
  for (let gradually of graduallyList) {
    const spans = gradually.querySelectorAll('span')
    const paragraph = gradually.querySelector('.sp-detail')

    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // 给每个 span 和 i 动画
            spans.forEach((span, index) => {
              span.style.animation = `swift-up-fade 0.5s ease forwards`
              span.style.animationDelay = `${index * 0.1}s`

              const i = span.querySelector('i')
              if (i) {
                i.style.animation = `swift-up-fade 0.5s ease forwards`
                i.style.animationDelay = `${index * 0.1}s`
              }
            })

            // 段落
            const totalDelay = spans.length * 0.1 + 0.3
            if (paragraph) {
              paragraph.style.animation = `swift-up-fade2 0.5s ease forwards`
              paragraph.style.animationDelay = `${totalDelay}s`
            }

            observer.unobserve(gradually)
          }
        })
      },
      {
        threshold: 0.3,
      }
    )
    observer.observe(gradually)
  }
}

mainRender()
